mutation deleteHifoCascadePitchMaterial($id: ID!) {
  deleteHifoCascadePitchMaterial(input: { id: $id }) {
    success
  }
}
